<template>
  <div>
    <content-header>{{ $t('editProject') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <text-area-input id="address" :name="$t('address')" :validate="$v" :is-loading="isLoading" />
            <file-input
                id="logo"
                :name="$t('logo')"
                @fileAdded="base64File => form.logo = base64File"
            />
            <file-input
                id="attachment"
                :name="$t('attachment')"
                @fileAdded="base64File => form.attachment = base64File"
            />
            <text-area-input id="note" :name="$t('note')" :validate="$v" :is-loading="isLoading" />
            <submit-input icon="fa-save" :name="$t('save')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {Project} from "@/models/Project";
import SubmitInput from "@/components/Inputs/SubmitInput";
import TextInput from "@/components/Inputs/TextInput";
import FileInput from "@/components/Inputs/FileInput";
import TextAreaInput from "@/components/Inputs/TextAreaInput";

export default {
  name: "ProjectEdit",
  components: {TextAreaInput, FileInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading, TextInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new Project().fillAbles),
      isLoading: false,
      selectedItem: {},
    };
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch('projects/GET_ONE', this.$route.params.id).then((response) => {
      this.form       = response.data;
      this.isLoading  = false;
    }).catch(() => this.isLoading = false)
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
      address: {},
      logo: {},
      attachment: {},
      note: {}
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('projects/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "projects"})
      }).catch(() => this.isLoading = false);
    }
  }
}
</script>
